<template>
  <button
    class="panel-section text-left mx-0 w-full overflow-hidden last-of-type:mb-0 relative"
    @click="onDlpStoreCardClick"
    @mouseenter="!$mq.bp768 && onMouseEnter()"
    @mouseleave="!$mq.bp768 && onMouseLeave()">
    <span class="panel-section__line mb-3 font-bold text-sm.5 cursor-pointer flex items-center justify-start gap-2">
      <span
        :class="[
        'rounded-full w-8 h-8 flex items-center justify-center text-xs.5 font-bold',
          isSelected ? 'bg-deep-forest text-white' : 'bg-beryl-green',
      ]">
        <icon-shop />
      </span>
      {{ deliveryPoint.groupName }}
    </span>

    <potager-button
      v-if="closable"
      class="absolute right-1 top-1"
      is-circle
      prevent
      size="small"
      theme="transparent"
      @onClick="$emit('onClose')">
      <template #icon>
        <icon-close class="text-xs" />
      </template>
    </potager-button>

    <a
      :href="`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent('Potager City ' + deliveryPoint.groupDeliveryAddress)}`"
      class="panel-section__line text-sm font-medium cursor-pointer flex justify-start items-center gap-2 hover:underline"
      rel="noopener noreferrer"
      target="_blank"
    >
      <span class="potager-button__icon">
        <icon-two-pin-marker class="text-xl" />
      </span>
      <span class="text-sm.5 font-normal">
          {{ deliveryPoint.groupDeliveryAddress }}
        </span>
    </a>

    <panel-section-navigator
      :to="`tel:${deliveryPoint?.phoneNumber}`"
      class="text-sm font-medium">
      <template #left>
        <icon-calendar class="text-xl" />
      </template>
      <span class="text-sm.5 font-normal">
        {{ deliveryPoint?.phoneNumber?.replace(/(\d{2})(?=\d)/g, '$1 ') }}
      </span>
      <template #arrow>
        Appeler
      </template>
    </panel-section-navigator>

    <panel-section-navigator :onClick="() => showOpeningHours = !showOpeningHours" class="text-sm font-medium">
      <template #left>
        <icon-calendar class="text-xl" />
      </template>
      <span class="text-sm.5 font-normal">
        Horaires d'ouverture
      </span>
      <template #arrow>
        {{ showOpeningHours ? 'Masquer' : 'Afficher' }}
      </template>
    </panel-section-navigator>

    <transition name="collapse-in">
      <div v-if="showOpeningHours" class="text-center grid grid-cols-4 gap-[1px] h-[125px] mt-3">
        <div
          v-for="({day, start, end}) in deliveryPoint?.openingHours"
          class="bg-white-rock py-4">
          <p class="text-xxs.5 font-semibold uppercase">
            {{ day }}
          </p>
          <p class="text-xxs font-normal">
            {{ start }}
            <template v-if="end">- {{ end }}</template>
          </p>
        </div>
        <div v-for="i in 8 - deliveryPoint?.openingHours?.length" :key="i" class="bg-white-rock" />
      </div>
    </transition>
  </button>
</template>

<script>
import PotagerButton from 'UI/PotagerButton';

import IconClose from 'Icons/regular/IconClose';
import IconShop from 'Icons/bold/IconShop';
import IconTwoPinMarker from 'Icons/bold/IconTwoPinMarker';
import IconCalendar from 'Icons/bold/IconCalendar';

import PanelSectionNavigator from 'Components/panel/section/PanelSectionNavigator';

import { mapGetters, mapMutations } from 'vuex';
import { UPDATE_SELECTED_DELIVERY_POINT, UPDATE_STORE_MARKER } from 'Stores/types/mapMutationsTypes';

export default {
  components: {
    PanelSectionNavigator,
    PotagerButton,
    IconClose,
    IconShop,
    IconTwoPinMarker,
    IconCalendar,
  },

  data() {
    return {
      showOpeningHours: false,
      previousHover: null,
    };
  },

  props: {
    deliveryPoint: {
      type: Object,
      required: true,
    },
    closable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  watch: {
    isSelected: {
      handler(value) {
        this.showOpeningHours = false;
        if (!this.$mq.bp768) this.showOpeningHours = value;
      },
      immediate: true,
    },
  },

  computed: {
    ...mapGetters('map', [
      'getSelectedDeliveryPoint',
    ]),
    isSelected() {
      return this.getSelectedDeliveryPoint?.id === this.deliveryPoint.id;
    },
  },

  methods: {
    ...mapMutations('map', [
      UPDATE_STORE_MARKER,
      UPDATE_SELECTED_DELIVERY_POINT,
    ]),
    onMouseEnter() {
      this.previousHover = this.getSelectedDeliveryPoint;
      this.UPDATE_STORE_MARKER(this.deliveryPoint);
    },
    onMouseLeave() {
      this.UPDATE_STORE_MARKER(this.previousHover);
    },
    onDlpStoreCardClick() {
      this.UPDATE_SELECTED_DELIVERY_POINT(this.deliveryPoint);
      this.$emit('onSelect', this.deliveryPoint);
    },
  }
};
</script>
